module.exports = __webpack_public_path__ + "static/media/moon.f067b627.svg";